import React from 'react';
import {Button} from '@betareader/design-system';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import AppIcon from '../../components/AppIcon';

import './publicPages.css';

export const About = ({user, changePage}) => (
  <main className='br-public-page br-public-page--text'>
    <h1>What is this?</h1>
    <p><strong>BetaReader.io</strong> is the brainchild of Swedish writer and tinkerer Jonas Frid. The idea for the tool came when I was a few weeks into the beta reading process of my coming novel, and I got frustrated by how bad of an overview I had of the entire thing.</p>
    <p>I had 20+ beta readers who all wanted the book delivered in different shapes and formats. Once I had sorted that and waited for their much valued feedback, I had no idea how far each reader had come <em>(I had to push myself not to ping them everyday and ask!)</em>. And then, when the feedback finally started coming in, only half of my readers provided it in the format I had requested, and they all sent it through different channels.</p>
    <p>Somewhere around this time, the epiphany hit me – this process can and should be simpler. Enter BetaReader, a beautiful web app that works everywhere. One, simple place to share my work and manage my readers and feedback.</p>
    <p>"How hard can that be?" I thought. When I don't make up stories, I'm a tinkerer and programmer at heart, so I, if anyone, should be able to pull it off!</p>
    <p>Turns out, "that" was quite hard – almost as hard as finishing a novel. Good thing I'm not the type who gives up. Many sweaty nights later, <strong>BetaReader.io</strong> was ready to be shared with the world. It's currenly (fittingly) in beta, which means I'd love you to try it out and help me make it better.</p>
    {user === undefined && (
      <div>
        <p>Why don't you sign up and let me know what you think?</p>
        <Button onClick={() => changePage('/signup')}>
          Join our Private Beta (it's free!) <AppIcon name='right arrow' aria-hidden='true' />
        </Button>
      </div>
    )}
  </main>
);

const mapStateToProps = state => ({user: state.user.user});
const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(About));
